module.exports = __webpack_public_path__ + "password-manager.2587db1.png";